import { createContext } from 'react';

const bottomNavbarContext = createContext();

export default bottomNavbarContext;
